const SocketEndpint = "http://localhost:5000";

export default SocketEndpint;
